import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-shopping-cart"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      transform: "translate(12 13)",
      class: ""
    }, [
      _createElementVNode("circle", {
        cx: "7.2",
        cy: "17.1",
        r: "1",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("circle", {
        cx: "17.2",
        cy: "17.1",
        r: "1",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M0-0.1h3.6L6.1,12c0.2,0.9,0.9,1.5,1.8,1.5h8.8c0.9,0,1.6-0.6,1.8-1.5L20,4.4H4.5",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }